import React from 'react';
import classes from './EnableDisableModal.css';
import Aux from '../../../../hoc/Wrap/Wrap';
import Backdrop from '../../../../UI/Backdrop/Backdrop';

const EnableDisableModal = (props) => {

        return (
            <Aux>
                <Backdrop show={props.show} /*clicked={props.modalClosed}*/ />
                <div className={classes.Modal}
                     style={{
                         transform: props.show ? 'translateY(0)' : 'translateY(-100vh)',
                         opacity: props.show ? '1':'0'
                     }}>
                    {props.children}
                </div>
            </Aux>
        );
}

export default EnableDisableModal;
